import { AfterViewInit, Component, OnInit, OnDestroy } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { generateUUID } from 'src/app/core/generators/generateUUID';
import {
  ICreateLaudoHigienizacao,
  IEditLaudoHigienizacao,
  IGetLaudoHigienizacaoById,
} from 'src/app/services/LaudoHigienizacaoService/laudo-higienizacao.model';
import {
  formatarData,
  validarCPF,
} from 'src/app/core/utils/utilities';
import { ServicoEntradaService } from 'src/app/services/ServicoEntradaService/servicoEntrada.service';
import { IGetServicoEntradaByServicoEntradaCavalo } from 'src/app/services/ServicoEntradaService/servicoEntrada.model';
import { LaudoHigienizacaoService } from 'src/app/services/LaudoHigienizacaoService/laudo-higienizacao.service';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';
import { CaminhaoService } from 'src/app/services/CaminhaoService/caminhao.service';
import { TransportadoraService } from 'src/app/services/TransportadoraService/transportadora.service';
import { IGetTransportadora } from 'src/app/services/TransportadoraService/transportadora.model';
import { DestinatarioService } from 'src/app/services/DestinatarioService/destinatario.service';

type IOptions = {
  name: string;
  value: string | number;
};

@Component({
  selector: 'app-cadastro-laudo-higienizacao',
  templateUrl: './cadastro-laudo-higienizacao.component.html',
  styleUrls: ['./cadastro-laudo-higienizacao.component.scss'],
})
export class CadastroLaudoHigienizacaoComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  private subscription$ = new Subscription();
  form: FormGroup;
  activeRoute: string = '';

  pkLaudo: number = 0;
  disabledLaudo: boolean = false;
  title: string = 'Cadastrar Laudo de Higiênização';
  isEditing: boolean = false;
  dataCriacaoLaudo: string | null = null;

  private readonly camposSomenteLeitura = [
    'TX_CRRT_1',
    'TX_CRRT_2',
    'TX_CRRT_3',
    'TX_TIPO_CRRT',
    'TX_TIPO_CRGA',
    'DT_SRVC_ENTR',
  ];

  statusInput: boolean = false;
  guid = generateUUID();
  servicoEntradaId: number = 0;
  isLoading: boolean = false;

  transportadoras: IGetTransportadora[] = [];
  transportadorasOptions: IOptions[] = [];
  terminalOptions: IOptions[] = [];

  tipoLaudoOptions: IOptions[] = [
    {
      name: '',
      value: '',
    },
  ];

  motoristaOptions: IOptions[] = [
    {
      name: '',
      value: '',
    },
  ];

  itensInspecao = [
    {
      numero: 1,
      id: 'item_1',
      descricao: 'As lonas estão em boas condições (sem furo)?',
    },
    {
      numero: 2,
      id: 'item_2',
      descricao: 'A carroceria está limpa?',
    },
    {
      numero: 3,
      id: 'item_3',
      descricao: 'Todas as bocas estão limpas e tampadas?',
    },
    {
      numero: 4,
      id: 'item_4',
      descricao: 'Ausência de ponto de infiltração de água?',
    },
    {
      numero: 5,
      id: 'item_5',
      descricao: 'O para-choque traseiro está limpo?',
    },
    {
      numero: 6,
      id: 'item_6',
      descricao: 'Ausência de resíduos nas grades?',
    },
    {
      numero: 7,
      id: 'item_7',
      descricao: 'Ausência de resíduos no estepe?',
    },
  ];

  formArrayInspecoes: FormArray;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private servicoEntradaService: ServicoEntradaService,
    private laudoHigienizacaoService: LaudoHigienizacaoService,
    public dialog: MatDialog,
    public swalAlert: SwalAlertService,
    public caminhaoService: CaminhaoService,
    private transportadoraService: TransportadoraService,
    private destinatarioService: DestinatarioService
  ) {
    this.formArrayInspecoes = this.fb.array([]);
    this.form = this.initForm();
  }

  createPayload(): ICreateLaudoHigienizacao | IEditLaudoHigienizacao {
    const formValues = this.isEditing ? this.form.getRawValue() : this.form.value;
    const inspecoesPayload = this.formArrayInspecoes.getRawValue().map((item: any) => ({
      Numero: item.perguntaNumero,
      Flag: item.resposta == 1 ? true : false,
      Observacao: item.observacao,
    }));

    return {
      TX_OBSV: formValues.TX_OBSV,
      TX_RG: formValues.TX_RG,
      QT_KM_CAVA: Number(formValues.QT_KM),
      FK_SRVC_ENTR: Number(formValues.FK_SRVC_ENTR),
      FK_FUNC_OPER: Number(localStorage.getItem('id')),
      NM_FUNC_OPER: formValues.NM_OPER,
      NM_TRND: formValues.NM_TRND,
      TX_CPF_CNPJ_TRND: formValues.TX_CPF_CNPJ_TRND,
      NU_TELE_TRND: formValues.NU_TELE_TRND,
      TX_CPF: formValues.TX_CPF,
      NM_MTRT: formValues.NM_MTRT,
      TX_PLCA_CAVA: formValues.TX_PLCA_CAVA,
      DadosInspecao: inspecoesPayload,
      TX_CRGM: formValues.TX_CRGM,
      DT_INIT: formValues.DT_INIT,
      DT_TERM: formValues.DT_TERM,
    };
  }

  // verificarDadosInspecao(): void {
  //   console.log('Dados das inspeções:', this.formArrayInspecoes.value);
  // }

  initForm(): FormGroup {
    const idEmpresa = localStorage.getItem('id') || '1';
    const form = this.fb.group({
      TX_PLCA_CAVA: this.fb.control('', {
        nonNullable: true,
        validators: [Validators.required],
      }),
      QT_KM: this.fb.control(''),
      PK_AGND: this.fb.control(''),
      FK_SRVC_ENTR: this.fb.control(''),
      FK_TPTD: this.fb.control(''),
      NM_TRND: this.fb.control('', {
        nonNullable: true,
        validators: [Validators.required],
      }),
      TX_CPF_CNPJ_TRND: this.fb.control(''),
      DT_SRVC_ENTR: this.fb.control(''),
      NU_TELE_TRND: this.fb.control(''),
      NM_MTRT: this.fb.control('', Validators.required),
      TX_RG: this.fb.control(''),
      TX_CPF: this.fb.control('', {
        nonNullable: true,
        validators: [Validators.required, Validators.minLength(11), validarCPF],
      }),
      TX_CRRT_1: this.fb.control(''),
      TX_CRRT_2: this.fb.control(''),
      TX_CRRT_3: this.fb.control(''),
      TX_TIPO_CRRT: this.fb.control(''),
      TX_TIPO_CRGA: this.fb.control(''),
      NM_OPER: this.fb.control('', {
        nonNullable: true,
        validators: [Validators.required],
      }),
      TX_OBSV: this.fb.control(''),
      TX_CRGM: this.fb.control(''),
      DT_INIT: this.fb.control(''),
      DT_TERM: this.fb.control(''),
    });
    return form;
  }

  initializeFormArrayInspecoes(): void {
    while (this.formArrayInspecoes.length > 0) {
      this.formArrayInspecoes.removeAt(0);
    }

    this.itensInspecao.forEach((item) => {
      this.formArrayInspecoes.push(
        this.fb.group({
          perguntaId: [item.id],
          perguntaNumero: [item.numero],
          perguntaTexto: [item.descricao],
          resposta: [1],
          observacao: [''],
        })
      );
    });
  }

  postarDados() {
    if (this.isEditing && this.disabledLaudo) {
      this.swalAlert.showAlert(
        'Atenção!',
        'O prazo de 48 horas para edição deste laudo expirou.',
        'warning'
      );
      return;
    }

    const inspecoesCompletas = this.verificarInspecoesCompletas();

    if (!inspecoesCompletas) {
      this.swalAlert.showAlert(
        'Atenção!',
        'Por favor, responda todos os itens da inspeção.',
        'warning'
      );
      return;
    }
    const payload = this.createPayload();

    if (this.form.valid) {
      this.isLoading = true;

      if (this.title.includes('Editar')) {
        this.laudoHigienizacaoService
          .EditarLaudoHigienizacao(this.pkLaudo, payload)
          .subscribe(
            (response) => {
              this.isLoading = false;
              this.router.navigate(['listagem/laudos-higienizacao']);
            },
            (error) => {
              this.isLoading = false;
            }
          );
      } else if (this.title.includes('Cadastrar')) {
        this.laudoHigienizacaoService
          .CreateLaudoHigienizacao(payload, this.guid)
          .subscribe(
            (response) => {
              this.isLoading = false;
              this.router.navigate(['listagem/laudos-higienizacao'], {
                queryParams: { codigo: response.PK_LAUD_SRVC, print: true }
              });
            },
            (error) => {
              this.isLoading = false;
            }
          );
      }
    } else {
      this.swalAlert.showAlert(
        'Atenção!',
        'Verifique se todos os campos obrigatórios foram preenchidos corretamente.',
        'warning'
      );
    }
  }

  verificarInspecoesCompletas(): boolean {
    const inspecoes = this.formArrayInspecoes.getRawValue();
    for (let i = 0; i < inspecoes.length; i++) {
      const resposta = inspecoes[i]?.resposta;

      if (resposta === null || resposta === '') {
        return false;
      }
    }
    return true;
  }

  ngOnInit(): void {
    this.initializeFormArrayInspecoes();
    this.autoFillDates();
    this.carregarTransportadoras();
    this.carregarTerminais();

    const nomeOperador = localStorage.getItem('nome');
    if (nomeOperador) {
      this.form.controls['NM_OPER'].setValue(nomeOperador);
    }
  }

  carregarTerminais(): void {
    this.destinatarioService.getDestinatarios().subscribe({
      next: (res: any) => {
        if (res?.Destinatarios) {
          this.terminalOptions = res.Destinatarios.map((d: any) => ({
            name: d.NM_DTNR,
            value: d.NM_DTNR
          }));
        }
      }
    });
  }

  autoFillDates(): void {
    if (this.isEditing) return;

    const now = new Date();
    const tzOffset = now.getTimezoneOffset() * 60000;
    const localISOTime = new Date(now.getTime() - tzOffset).toISOString().slice(0, 16);

    this.form.controls['DT_INIT'].setValue(localISOTime);
    this.form.controls['DT_TERM'].setValue(localISOTime);
  }

  ngAfterViewInit(): void {
    this.route.queryParams.subscribe((params) => {
      if (params['codigo']) {
        this.title = 'Editar Laudo de Higienização';
        this.isEditing = true;
        this.disabledLaudo = false;
        this.isLoading = true;
        this.laudoHigienizacaoService
          .GetLaudoHigienizacaoById(Number(params['codigo']))
          .subscribe({
            next: (response: IGetLaudoHigienizacaoById) => {
              this.pkLaudo = response.PK_LAUD_SRVC;
              this.form.controls['FK_SRVC_ENTR'].setValue(
                Number(response.FK_SRVC_ENTR)
              );
              this.form.controls['QT_KM'].setValue(response.QT_KM_CAVA);
              this.form.controls['TX_RG'].setValue(response.TX_RG);
              this.form.controls['TX_OBSV'].setValue(response.TX_OBSV);
              this.form.controls['NM_OPER'].setValue(response.NM_FUNC_OPER);
              this.form.controls['TX_CPF'].setValue(response.TX_CPF);
              this.form.controls['NU_TELE_TRND'].setValue(
                response.NU_TELE_TRND
              );
              this.form.controls['NM_TRND'].setValue(response.NM_TRND);
              this.sincronizarTransportadoraSelecionada(response.NM_TRND);
              this.form.controls['NM_MTRT'].setValue(response.NM_MTRT);
              this.form.controls['DT_INIT'].setValue(
                response.DT_INIT?.toString().slice(0, 16)
              );
              this.form.controls['DT_TERM'].setValue(
                response.DT_TERM?.toString().slice(0, 16)
              );
              this.form.controls['TX_CRGM'].setValue(response.TX_CRGM);
              this.form.controls['TX_CPF_CNPJ_TRND'].setValue(
                response.TX_CPF_CNPJ_TRND
              );
              this.servicoEntradaId = response.FK_SRVC_ENTR;

              if (response.INSPECOES) {
                this.carregarInspecoes(response.INSPECOES);
              }

              this.dataCriacaoLaudo = response.DT_CRIA ?? null;
              this.aplicarRestricaoEdicaoPorPrazo(this.dataCriacaoLaudo ?? undefined);

              this.isLoading = false;
              this.getServicoEntrada(response.FK_SRVC_ENTR);
            },
          });
      } else if (params['placa']) {
        this.form.controls['TX_PLCA_CAVA'].setValue(params['placa']);
        this.getServicoEntrada();
      }
    });
  }

  aplicarRestricaoEdicaoPorPrazo(dtCria?: string): void {
    const podeEditar = dtCria ? this.dentroPrazoEdicao(dtCria) : false;

    Object.keys(this.form.controls).forEach((nome) => {
      if (this.camposSomenteLeitura.includes(nome)) {
        this.form.get(nome)?.disable({ emitEvent: false });
        return;
      }

      if (podeEditar) {
        this.form.get(nome)?.enable({ emitEvent: false });
      } else {
        this.form.get(nome)?.disable({ emitEvent: false });
      }
    });

    if (podeEditar) {
      this.formArrayInspecoes.enable({ emitEvent: false });
      this.disabledLaudo = false;
      return;
    }

    this.formArrayInspecoes.disable({ emitEvent: false });
    this.disabledLaudo = true;

    if (dtCria) {
      this.swalAlert.showAlert(
        'Atenção!',
        'O prazo de 48 horas para edição deste laudo expirou.',
        'warning'
      );
    }
  }

  dentroPrazoEdicao(dtCria: string): boolean {
    const diffHours =
      (Date.now() - new Date(dtCria).getTime()) / (1000 * 60 * 60);
    return diffHours <= 48;
  }

  carregarInspecoes(inspecoesData: any[]): void {
    this.initializeFormArrayInspecoes();

    inspecoesData.forEach((item, index) => {
      if (index < this.formArrayInspecoes.length) {
        const grupo = this.formArrayInspecoes.at(index) as FormGroup;
        grupo.patchValue({
          resposta: item.resposta,
          observacao: item.observacao || '',
        });
      }
    });
  }

  setForms() {
    if (this.isEditing) return;

    this.clearForms();
    this.getServicoEntrada();
  }

  carregarTransportadoras(): void {
    this.transportadoraService.GetTransportadoras().subscribe({
      next: (res: any) => {
        if (res?.Transportadoras) {
          this.transportadoras = res.Transportadoras;
          this.transportadorasOptions = this.transportadoras.map((t) => ({
            name: t.NM_TPTD,
            value: t.PK_TPTD,
          }));
          this.sincronizarTransportadoraSelecionada(
            this.form.controls['NM_TRND'].value
          );
        }
      },
    });
  }

  private sincronizarTransportadoraSelecionada(nomeTransportadora?: string): void {
    if (!nomeTransportadora) return;

    const transportadora = this.transportadoras.find(
      (t) => t.NM_TPTD === nomeTransportadora
    );
    if (transportadora) {
      this.form.controls['FK_TPTD'].setValue(transportadora.PK_TPTD);
    }
  }

  onTransportadoraSelecionada(pkTptd: any): void {
    const t = this.transportadoras.find((t) => t.PK_TPTD === Number(pkTptd));
    if (!t) return;
    this.form.controls['NM_TRND'].setValue(t.NM_TPTD);
    this.form.controls['TX_CPF_CNPJ_TRND'].setValue(t.TX_CNPJ_TPTD ?? '');
    this.form.controls['NU_TELE_TRND'].setValue(t.TX_CNTT_TPTD ?? '');
  }

  getServicoEntrada(servicoEntradaId?: number) {
    this.isLoading = true;
    const placaCavalo = this.form.controls['TX_PLCA_CAVA'].value;
    const numeroAgendamento = this.form.controls['PK_AGND'].value;
    const invalid = [null, '', undefined, 0];

    if (
      !invalid.includes(placaCavalo) ||
      !invalid.includes(servicoEntradaId) ||
      !invalid.includes(numeroAgendamento)
    ) {
      this.servicoEntradaService
        .GetServicoEntradaByServicoEntradaAndCavalo({
          PK_SRVC_ENTR: servicoEntradaId,
          PK_SRVC: servicoEntradaId ? undefined : 3,
          PK_AGND: numeroAgendamento,
          TX_PLCA_CAVA: placaCavalo,
        })
        .subscribe({
          next: (response: IGetServicoEntradaByServicoEntradaCavalo) => {
            if (response.TX_PLCA_CAVA) {
              this.form.controls['TX_PLCA_CAVA'].setValue(response.TX_PLCA_CAVA);
            }
            this.form.controls['TX_CRRT_1'].setValue(response.TX_PLCA_CRRT_1);
            this.form.controls['TX_CRRT_2'].setValue(response.TX_PLCA_CRRT_2);
            this.form.controls['TX_CRRT_3'].setValue(response.TX_PLCA_CRRT_3);

            this.form.controls['FK_SRVC_ENTR'].setValue(response.PK_SRVC_ENTR);
            this.form.controls['DT_SRVC_ENTR'].setValue(
              formatarData(response.DT_SRVC_ENTR)
            );

            if (!this.form.controls['NM_MTRT'].value)
              this.form.controls['NM_MTRT'].setValue(response.NM_USUA_MTRT);
            this.form.controls['TX_TIPO_CRRT'].setValue(response.NM_TIPO_CRRT);
            this.form.controls['TX_TIPO_CRGA'].setValue(response.TX_CRGA);
            this.form.controls['PK_AGND'].setValue(response.PK_AGND);

            if (!this.form.controls['TX_CPF_CNPJ_TRND'].value)
              this.form.controls['TX_CPF_CNPJ_TRND'].setValue(
                response.TX_CNPJ_EPSA
              );
            if (!this.form.controls['TX_CPF'].value)
              this.form.controls['TX_CPF'].setValue(response.TX_CPF_MTRT);
            if (!this.form.controls['NU_TELE_TRND'].value)
              this.form.controls['NU_TELE_TRND'].setValue(
                response.NU_TELE_EPSA
              );
            const nomeTransportadora =
              (response as any).NM_TPTD ?? response.NM_FNTS_EPSA;
            if (!this.form.controls['NM_TRND'].value && nomeTransportadora) {
              this.form.controls['NM_TRND'].setValue(nomeTransportadora);
              this.sincronizarTransportadoraSelecionada(nomeTransportadora);
            }

            if (!this.isEditing && !this.form.controls['TX_CRGM'].value && response.NM_DTNR)
              this.form.controls['TX_CRGM'].setValue(response.NM_DTNR);

            this.isLoading = false;
          },
          error: (error: any) => {
            this.swalAlert.handleError(
              error,
              'Atenção!',
              'Ocorreu um erro ao realizar a busca através da Placa do Cavalo ou Número do serviço, por favor, tente novamente.',
              'warning'
            );
            this.isLoading = false;
          },
          complete: () => {
            this.isLoading = false;
          },
        });
    }

    this.isLoading = false;
  }

  clearForms(): void {
    const placaCavalo = this.form.controls['TX_PLCA_CAVA'].value;

    if (placaCavalo == '') this.form.reset();
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }
}
